// ShareBite recent-achievements selection (Task 7.7).
//
// Pure selector used by the Restaurant and NGO dashboards to surface a User's
// most recently earned badges. Given a User's set of earned Achievements, it
// returns them ordered from most recently earned to least recently earned and
// limited to at most five entries. The function is platform-independent and
// side-effect free; it never mutates its input.
//
// Design reference: design.md "Property 24: Recent-achievements ordering and
// limit".
// Requirements:
//   31.3 - The User's dashboard displays the User's most recent achievements,
//          ordered from most recently earned to least recently earned, limited
//          to a maximum of 5 achievements.
/** Maximum number of achievements surfaced in the recent-achievements list. */
export const RECENT_ACHIEVEMENTS_LIMIT = 5;
/**
 * Select a User's most recent achievements (Req 31.3).
 *
 * Returns a new array containing the given Achievements ordered from most
 * recently earned to least recently earned (by `earnedAt` descending) and
 * truncated to at most {@link RECENT_ACHIEVEMENTS_LIMIT} entries.
 *
 * This function is pure: it copies the input before sorting, so the caller's
 * array is never mutated, and it produces no side effects.
 *
 * @param achievements The User's earned Achievements (any order).
 * @returns A new array of at most 5 Achievements, most-recent-first.
 */
export function recentAchievements(achievements) {
    return [...achievements]
        .sort((a, b) => b.earnedAt - a.earnedAt)
        .slice(0, RECENT_ACHIEVEMENTS_LIMIT);
}
//# sourceMappingURL=recentAchievements.js.map